import { useEffect, useState } from "react";
import { FormifyInputStyle } from "../../../../assets/styles";
import Moment from "../../../../modules/Moment/Moment";
import req from "../../../../modules/Request";
import { clsx } from "../../../../modules/Utilkit/Utilkit";
import { useNotify } from "../../../components/Notify";


const CutForm = ({ task, setTasks, onClose, holidays }) => {
  const { notify } = useNotify();

  const min = task.split?.start ?? task.start;
  const max = task.split?.end ?? task.end;

  const [ from, setFrom ] = useState(task.selectedDate);
  const [ to, setTo ] = useState(task.selectedDate);

  useEffect(() => {
    // Fix: Correct validation for invalid dates
    if (!task.selectedDate || isNaN(new Date(task.selectedDate).getTime())) {
      return;
    }
    
    let availableFrom = new Moment(task.selectedDate).add(-1).value();
    let availableTo = new Moment(task.selectedDate).add(1).value();

    while (holidays.includes(availableFrom)) {
      availableFrom = new Moment(availableFrom).add(-1).value();
    }

    while (holidays.includes(availableTo)) {
      availableTo = new Moment(availableTo).add(1).value();
    }

    setFrom(availableFrom);
    setTo(availableTo);
  }, [ task, holidays ]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Fix: Correct validation for invalid dates
    if(isNaN(new Date(from).getTime()) || isNaN(new Date(to).getTime())) {
      notify('Taglio Dal e Taglio Al', 'Inserire una data valida.', 'error');
      return;
    } else if(new Date(from) > new Date(to)) {
      notify('Taglio Dal', 'La data di inizio non può essere maggiore della data di fine.', 'error');
      return;
    } else if(new Date(from) < new Date(min) || new Date(to) > new Date(max)) {
      notify('Taglio Dal e Taglio Al', 'Le date inserite non possono essere al di fuori del range del task.', 'error');
      return;
    }

    req("new-split", { id: task.split?.id ?? task.id, father: task.id, from, to })
      .then((res) => {
        if (res.success) {
          setTasks((tasks) => tasks.map(t => {
            if (t.id === task.id) {
              return {
                ...t,
                dates: res.data.map(st => {
                  return {
                    ...st,
                    isDraggable: true,
                    isResizable: true
                  };
                })
              };
            } else {
              return t;
            }
          }));
        } else {
          notify(res.error, "Errore durante la divisione del task.", 'error');
        }
      });
    onClose();
  };

  return (
    <form className="min-w-[220px] flex flex-col items-center text-center" onSubmit={ handleSubmit }>
      <div className="w-full font-semibold border-b border-gray-400">
        Modifica Task
      </div>

      <div className="flex flex-col justify-center items-center space-y-1 pb-2">
        <div className="flex flex-col w-full">
          <label>Taglio Dal</label>

          <input
            type="date"
            className={ FormifyInputStyle }
            value={ from }
            onInput={ (e) => setFrom(e.target.value) }
            onInvalid={ (e) => {
              e.preventDefault();
              notify('Taglio Dal', e.target.validationMessage, 'error');
            } }
            max={ to && !isNaN(new Date(to).getTime()) ? new Moment(to).add(-1).value() : '' }
            min={ min && !isNaN(new Date(min).getTime()) ? new Moment(min).value() : '' }
          />
        </div>

        <div className="flex flex-col w-full">
          <label>Taglio Al</label>

          <input
            type="date"
            className={ FormifyInputStyle }
            value={ to }
            onInput={ (e) => setTo(e.target.value) }
            max={ max && !isNaN(new Date(max).getTime()) ? new Moment(max).value() : '' }
            min={ from && !isNaN(new Date(from).getTime()) ? new Moment(from).add(1).value() : '' }
          />
        </div>

        <button
          className={ clsx(
            "border disabled:bg-green-300 disabled:border-green-200 rounded-sm",
            "px-4 py-0.5 duration-75 bg-green-500 hover:bg-green-400 border-green-400",
            "hover:border-green-300 text-white"
          ) }
        >
          Taglia
        </button>
      </div>
    </form>
  );
};

export default CutForm;